import { getGalleryImageUrl } from "./galleryImage";

/** Gallery (Social Hub) — pass-through from Gallery Cloudinary URLs */
export function optimizeCloudinaryUrl(url) {
  return getGalleryImageUrl(url) || url;
}
